/** @const {!Map<number, !Array<string>>} */
const PITCH_TO_NOTE = new Map([
  [0, 'C'],
  [1, 'Db'],
  [2, 'D'],
  [3, 'Eb'],
  [4, 'E'],
  [5, 'F'],
  [6, 'Gb'],
  [7, 'G'],
  [8, 'Ab'],
  [9, 'A'],
  [10, 'Bb'],
  [11, 'B'],
]);

const BASE_C = 60;
const BASE_OCTAVE = 4;

/**
 * @param {number} index
 * @return {!Array<string>} Pitch name.
 */
function pitchIndexToPitchName(index) {
  return PITCH_TO_NOTE.get((index + BASE_C) % 12);
}

/**
 * @param {number} index
 * @return {number} Octave.
 */
function pitchIndexToOctave(index) {
  const basePitch = (index + BASE_C) % 12;
  return Math.floor(BASE_OCTAVE + (index - basePitch - BASE_C) / 12);
}

class NotesGrid {
  constructor(container) {
    this.container = container;
    this.gridContainer = document.createElement('div');
    this.gridContainer.id = 'grid';
    this.container.appendChild(this.gridContainer);
    this.divs = [];
    this.shown = false;
  }

  drawGrid(pitches, canvasWidth, canvasHeight, canvasX = 0, canvasY = 0) {
    let i = 0;
    let y = 0;

    for (const pitch of pitches) {
      let div = null,
        span = null;
      if (i < this.divs.length) {
        div = this.divs[i];
        span = div.firstChild;
      } else {
        div = document.createElement('div');
        span = document.createElement('span');
        div.classList.add('grid-div');
        div.appendChild(span);
        this.gridContainer.appendChild(div);
        this.divs.push(div);
      }

      // if we have more divs than pitches, remove the last div
      // This happens for the japanese scale, because it has less notes.
      while (this.divs.length > pitches.length) {
        this.gridContainer.removeChild(this.gridContainer.lastChild);
        this.divs.pop();
      }

      const pitchY = pitch.y * canvasHeight;
      const nextPitchY =
        i < pitches.length - 1 ? pitches[i + 1].y * canvasHeight : 0;
      const pitchH = pitchY - nextPitchY;
      const divy = pitchY - pitchH;
      span.textContent =
        pitchIndexToPitchName(pitch.pitch) + pitchIndexToOctave(pitch.pitch);
      div.style.width = `${canvasWidth - 90}px`;
      div.style.transform = `translateY(${divy}px)`;
      div.style.visibility = divy < 30 ? 'hidden' : 'inherit';

      y = pitchY;
      i++;
    }
  }

  changeColor(color) {
    for (const div of this.divs) {
      div.style.color = color;
      div.style.borderColor = color;
    }
  }

  clear() {
    while (this.gridContainer.firstChild) {
      this.gridContainer.removeChild(this.gridContainer.firstChild);
    }
  }

  toggleGrid() {
    if (!this.shown) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.gridContainer.style.visibility = 'inherit';
    this.gridContainer.classList.add('shown');
    this.shown = true;
  }

  hide() {
    this.gridContainer.classList.remove('shown');
    this.shown = false;
  }
}

export { NotesGrid };
